import React from "react";
import { InView } from "@tennr/frontend/components/InView";
import { Heading } from "@tennr/frontend/components/Heading";
import { urlForImage } from "@tennr/frontend/lib/sanity";
import type { CaseStudy } from "@tennr/frontend/../sanity.types";
import "./CaseStudyDetailHeroSection.css";

interface CaseStudyDetailHeroSectionProps {
  caseStudy: CaseStudy;
}

export const CaseStudyDetailHeroSection: React.FC<CaseStudyDetailHeroSectionProps> = ({ caseStudy }) => {
  // Handle both v1 and v2 structures
  const isV2 = (caseStudy as any)._type === "caseStudyV2";

  const title = isV2 ? (caseStudy as any).heroSection?.title || "CASE STUDY" : "CASE STUDY";

  const heading = isV2 ? (caseStudy as any).heroSection?.heading || caseStudy.company : caseStudy.title;

  // For v2, body is portable text array; for v1, it's a string
  const bodyContent = isV2
    ? (caseStudy as any).heroSection?.body
    : caseStudy.heroContent?.subtitle || caseStudy.heroContent?.description || "";

  // Convert portable text to plain text for the Heading component
  const body = Array.isArray(bodyContent)
    ? bodyContent.map((block: any) => block.children?.map((child: any) => child.text).join("") || "").join("\n")
    : bodyContent;

  return (
    <section className="case-study-detail-hero-section">
      <div className="case-study-detail-hero-content">
        <InView>
          <Heading title={title} heading={heading} body={body} variant="xl" position="left" dark />
        </InView>

        {caseStudy.companyLogo && (
          <InView delay={0.3}>
            <img
              src={urlForImage(caseStudy.companyLogo) || ""}
              alt={`${caseStudy.company} logo`}
              className="case-study-detail-hero-logo"
              draggable={false}
            />
          </InView>
        )}
      </div>
    </section>
  );
};
